import React from "react";

const Loader = ({ iswhitelabelenable = false }) => {
  // console.log({whitelabelStatus:iswhitelabelenable})
  return (
    <div
      className={`flex w-full h-full justify-center items-center ${
        iswhitelabelenable ? "bg-[#FCF9F6]" : ""
      }`}
    >
      <div
        className={`${
          iswhitelabelenable
            ? ` w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin` : " loader"
        }`}
      />
    </div>
  );
};

export default Loader;
